module.exports = __webpack_public_path__ + "img/menu-cad.31549846.svg";